<template>
  <div class="withdraw_index">
    <div class="withdraw_index_nav">
      <navbar
        title="开票详情"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.7rem'"
        :titlecolor="'#333'"
        @goback="goBack(false)"
      />
    </div>
    <div class="box">
      <van-row>
        <van-col span="24" class="title">实开金额</van-col>
        <van-col span="24" class="money">{{ invoiceInfo.amount }}</van-col>
        <van-col span="24" class="status success" v-if="invoiceInfo.status == 1"
          >已核销</van-col
        >
        <van-col span="24" class="status" v-if="invoiceInfo.status == 0"
          >待审核</van-col
        >
        <van-col span="24" class="status" v-if="invoiceInfo.status == 2"
          >审核驳回</van-col
        >
        <van-col span="24" class="item" v-if="invoiceInfo.status == 2">
          驳回原因
          <span>{{ invoiceInfo.reason }}</span>
        </van-col>
        <van-col span="24" class="item">
          开票ID
          <span>{{ invoiceInfo.bill_id }}</span>
        </van-col>
        <van-col span="24" class="item">
          账单日期
          <span>{{ formatDate(invoiceInfo.invoice_info.bill_date) }}</span>
        </van-col>
        <van-col span="24" class="item">
          应开金额
          <span>{{ invoiceInfo.invoice_info.payable_amount }}</span>
        </van-col>
        <van-col span="24" class="item">
          提交时间
          <span>{{ invoiceInfo.created_at }}</span>
        </van-col>
        <van-col span="24" class="item" v-if="invoiceInfo.status != 0">
          操作时间
          <span>{{ invoiceInfo.updated_at }}</span>
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      invoiceInfo: {},
    };
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.getInfo();
  },
  mounted() {
    document
      .querySelector(".box")
      .addEventListener("scroll", this.handleScroll);
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getInfo() {
      this.$api
        .post("member-relation/member/three/year/supplier/bill-detail", {
          bill_num: this.$route.query.bill_num,
        })
        .then((res) => {
          this.invoiceInfo = res.list[0];
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    formatDate(date) {
      return date.slice(0, 4) + "." + date.slice(4, 6);
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.withdraw_index {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .withdraw_index_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    z-index: 3;
    background: #fff;
  }

  .box {
    box-sizing: border-box;
    height: 100%;
    padding: 10.4rem 1.6rem 6rem;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .van-row {
      min-height: 31.2rem;
      padding: 3rem 2rem 0;
      background: #fff;
      border-radius: 0.8rem;
      box-sizing: border-box;

      .title {
        color: #999;
        font-size: 1.2rem;
        line-height: 1.7rem;
        text-align: center;
      }

      .money {
        color: #333;
        font-size: 3.2rem;
        line-height: 3.7rem;
        font-weight: 700;
        text-align: center;
        margin: 0.4rem 0 0.6rem;
      }

      .status {
        color: #ff4747;
        font-size: 1.4rem;
        line-height: 2rem;
        text-align: center;
        margin-bottom: 5.6rem;
      }

      .success {
        color: #333;
      }

      .item {
        line-height: 2rem;
        color: #999;
        font-size: 1.4rem;
        margin-bottom: 1.4rem;

        span {
          color: #999;
          font-size: 1.4rem;
          float: right;
          max-width: 18.7rem;
          text-align: right;
        }
      }
    }
  }
}
</style>


